import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Link from "next/link";
import { memo } from "react";
import { Routes } from "~/constants/routes";
export const SignupSSOTermsInfo = /*#__PURE__*/ memo(()=>/*#__PURE__*/ _jsxs("p", {
        className: "text-center text-12 text-pigeon-400",
        children: [
            "By signing up with SSO or email, you agree to Air's",
            " ",
            /*#__PURE__*/ _jsx(Link, {
                href: Routes.marketing.terms,
                target: "_blank",
                className: "text-pigeon-400 underline",
                children: "Terms of Service"
            }),
            " ",
            ",",
            " ",
            /*#__PURE__*/ _jsx(Link, {
                href: Routes.marketing.privacy,
                target: "_blank",
                className: "text-pigeon-400 underline",
                children: "Privacy Policy"
            }),
            ", and occasional email updates."
        ]
    }));
SignupSSOTermsInfo.displayName = "SignupSSOTermsInfo";
